import { axios } from '@lib/axios';

import type {
    ContractCreationParamsData,
    ContractListQueryParams,
    ContractListResponseData,
    ContractResponseData,
    ContractUpdateParamsData,
    ContractViewModelData,
} from 'chaika-frontend-types/frontend-cms';

const BASE_URL = '/api/contract';

export class ContractApi {
    public static async create(contract: ContractCreationParamsData): Promise<void> {
        await axios.post(BASE_URL, { contract });
    }

    public static async update(id: string, contract: ContractUpdateParamsData): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { contract });
    }

    public static async get(id: string): Promise<ContractViewModelData> {
        const res = await axios.get<ContractResponseData>(`${BASE_URL}/${id}`);

        return res.data.contract;
    }

    public static async getList(params: ContractListQueryParams): Promise<ContractViewModelData[]> {
        const res = await axios.get<ContractListResponseData>(BASE_URL, { params });

        return res.data.contracts;
    }
}

export { BASE_URL as CONTRACT_BASE_URL };
